module.exports = __webpack_public_path__ + "static/img/hx6.bde46b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hx6.png
// module id = 2G2S
// module chunks = 1